import { render, staticRenderFns } from "./publicWelfare.vue?vue&type=template&id=7241d2ff&scoped=true&"
import script from "./publicWelfare.vue?vue&type=script&lang=js&"
export * from "./publicWelfare.vue?vue&type=script&lang=js&"
import style0 from "./publicWelfare.vue?vue&type=style&index=0&id=7241d2ff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7241d2ff",
  null
  
)

export default component.exports